export default {
	DB_HYDRATE_OBSERVATION_FORM: 'DB_HYDRATE_OBSERVATION_FORM',
	DB_CLEAR_FORM: 'DB_CLEAR_FORM',
	DB_UPDATE_ACTIVITY: 'DB_UPDATE_ACTIVITY',
	DB_UPDATE_TYPE_OF_OBSERVATION: 'DB_UPDATE_TYPE_OF_OBSERVATION',
	DB_UPDATE_CONDITION: 'DB_UPDATE_CONDITION',
	DB_UPDATE_TEXT_FIELD: 'DB_UPDATE_TEXT_FIELD',
	DB_UPDATE_HAZARD_STATUS: 'DB_UPDATE_HAZARD_STATUS',
	DB_UPDATE_NEAR_MISSES: 'DB_UPDATE_NEAR_MISSES',
	DB_UPDATE_DATE: 'DB_UPDATE_DATE'
};
